module.exports = __webpack_public_path__ + "img/logo_lg.be19b5e4.png";